import React from 'react';
import LogisticNav from '../../components/logistic/LogisticNav';
import LogisticHero from '../../components/logistic/LogisticHero';
import LogisticPainSection from '../../components/logistic/LogisticPainSection';
import LogisticSolutionSection from '../../components/logistic/LogisticSolutionSection';
import LogisticFeaturesSection from '../../components/logistic/LogisticFeaturesSection';
import LogisticBenefitsSection from '../../components/logistic/LogisticBenefitsSection';
import LogisticUseCasesSection from '../../components/logistic/LogisticUseCasesSection';
import LogisticTestimonialsSection from '../../components/logistic/LogisticTestimonialsSection';
import LogisticGuaranteeSection from '../../components/logistic/LogisticGuaranteeSection';
import LogisticPricingSection from '../../components/logistic/LogisticPricingSection';
import LogisticUrgencySection from '../../components/logistic/LogisticUrgencySection';
import LogisticCtaSection from '../../components/logistic/LogisticCtaSection';
import LogisticFaqSection from '../../components/logistic/LogisticFaqSection';
import LogisticFooter from '../../components/logistic/LogisticFooter';

import "../../styles/logistic/LogisticGeneral.css";

const LogisticPage = () => {
  return (
    <div>
      <LogisticNav />
      <LogisticHero />
      <LogisticPainSection />
      <LogisticSolutionSection />
      <LogisticFeaturesSection />
      <LogisticBenefitsSection />
      <LogisticUseCasesSection />
      <LogisticTestimonialsSection />
      <LogisticGuaranteeSection />
      <LogisticPricingSection />
      <LogisticUrgencySection />
      <LogisticCtaSection />
      <LogisticFaqSection />
      <LogisticFooter />
      {/* Other sections of the logistic page will go here */}
    </div>
  );
};

export default LogisticPage;